define("calendar/utils/markupTags", ["exports", "later/utils/calendar/constants"], function (_exports, _constants) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.setMarkupTags = _exports.markupOptionsByTag = void 0;
  0; //eaimeta@70e063a35619d71f0,"later/utils/calendar/constants"eaimeta@70e063a35619d71f

  const setMarkupTags = event => {
    const tags = [];
    const {
      extendedProps
    } = event;
    const {
      autoPublish,
      hasError,
      isCarouselPost,
      isReel,
      locked,
      post,
      unverified
    } = extendedProps;

    if (post.isDestroyed) {
      return [];
    }

    const {
      isAutoPublishOnlyProfile,
      isAutoPublishing,
      isDraft,
      isNotificationPost,
      isText,
      isVideo,
      isVideoApproved,
      isVideoHidden,
      isVideoPending,
      isVideoPublishFailed,
      isVideoRejected,
      socialProfile
    } = post || {}; // Note: This code block runs on all non-Instagram/Tiktok posts. 'autoPublish' can only
    // be trusted on Instagram/Tiktok, and an identical div is appended later for those posts.

    if (isDraft) {
      tags.push('default.draft');
    } else if (isAutoPublishOnlyProfile && !isNotificationPost && !autoPublish && socialProfile?.get('hasPublishingMethod')) {
      hasError ? tags.push('autoPublish.error') : tags.push('default.default');
    } // Note: Text posts


    if (isText) {
      tags.push('text');
    } // Note: Tiktok with hidden video, locked, or unverified


    if (socialProfile?.get('isTiktok') && isVideoHidden) {
      tags.push('tiktokHiddenVideo');
    } else if (locked) {
      tags.push('locked');
    } else if (unverified) {
      tags.push('unverified');
    } // Note: Carousel posts


    if (isCarouselPost) {
      tags.push('carousel');
    } else if (isReel) {
      tags.push('isReel');
    } // Note: 'autoPublish' is only defined and valid for Instagram & Tiktok posts.


    if (autoPublish) {
      if (socialProfile?.get('isTiktok') && isVideoPublishFailed) {
        tags.push('tiktokVideoFail');
      } else if (isDraft) {
        tags.push('default.draft');
      } else if (hasError) {
        tags.push('autoPublish.error');
      } else {
        tags.push('default.default');
      }
    } // Note: Markup for notification based posts


    if (isNotificationPost) {
      if (isDraft) {
        tags.push('default.draft');
      } else if (hasError) {
        tags.push('notification.error');
      } else {
        tags.push('notification.default');
      }
    } // Note: Auto-publishing here is defined as any post in the process of being published


    if (isAutoPublishing) {
      tags.push('autoPublishing');
    } // Note: Add classes/markup based on Pinterest video states


    if (socialProfile?.get('isPinterest') && isVideo && !hasError) {
      if (isVideoApproved) {
        tags.push('pinterestVideo.approved');
      } else if (isVideoRejected) {
        tags.push('pinterestVideo.rejected');
      } else if (isVideoPending) {
        tags.push('pinterestVideo.pending');
      } else {
        tags.push('default.default');
      }
    }

    if (socialProfile?.get('isYoutube')) {
      tags.push('youtubeShort');
    }

    return tags;
  };

  _exports.setMarkupTags = setMarkupTags;

  const markupOptionsByTag = intl => ({
    default: {
      draft: {
        contentWrapperClasses: [_constants.POST_MARKUP_CLASSES.IS_DRAFT],
        className: _constants.POST_MARKUP_CLASSES.FC_METHOD,
        text: intl.t('calendar.publish_methods.draft')
      },
      default: {
        className: _constants.POST_MARKUP_CLASSES.FC_METHOD,
        icon: _constants.POST_MARKUP_ICONS.AUTO_PUBLISH,
        text: intl.t('calendar.publish_methods.auto_publish')
      }
    },
    text: {
      contentWrapperClasses: [_constants.POST_MARKUP_CLASSES.TEXT_POST]
    },
    tiktokHiddenVideo: [{
      contentWrapperClasses: [_constants.POST_MARKUP_CLASSES.IS_VERIFIED],
      className: _constants.POST_MARKUP_CLASSES.FC_METHOD,
      hasOverlay: true
    }, {
      className: _constants.POST_MARKUP_CLASSES.FC_STATUS,
      icon: _constants.POST_MARKUP_ICONS.HIDDEN,
      hasOverlay: true
    }],
    tiktokVideoFail: [{
      className: _constants.POST_MARKUP_CLASSES.FC_METHOD_DANGER,
      icon: _constants.POST_MARKUP_ICONS.WARNING,
      hasOverlay: true,
      text: intl.t('shared_words.error')
    }, {
      className: _constants.POST_MARKUP_CLASSES.FC_STATUS,
      hasOverlay: true
    }],
    locked: {
      contentWrapperClasses: [_constants.POST_MARKUP_CLASSES.IS_VERIFIED],
      className: _constants.POST_MARKUP_CLASSES.FC_STATUS,
      icon: _constants.POST_MARKUP_ICONS.FC_VERIFIED,
      hasOverlay: true
    },
    unverified: {
      contentWrapperClasses: [_constants.POST_MARKUP_CLASSES.IS_UNVERIFIED],
      className: _constants.POST_MARKUP_CLASSES.FC_STATUS,
      icon: _constants.POST_MARKUP_ICONS.HELP,
      hasOverlay: true
    },
    carousel: {
      className: _constants.POST_MARKUP_CLASSES.FC_TYPE,
      icon: _constants.POST_MARKUP_ICONS.GALLERY
    },
    isReel: {
      className: _constants.POST_MARKUP_CLASSES.FC_TYPE,
      icon: _constants.POST_MARKUP_ICONS.REELS
    },
    autoPublish: {
      error: {
        contentWrapperClasses: [_constants.POST_MARKUP_CLASSES.HAS_ERROR],
        className: _constants.POST_MARKUP_CLASSES.FC_METHOD_DANGER,
        icon: _constants.POST_MARKUP_ICONS.AUTO_PUBLISH_ERROR,
        hasOverlay: true,
        text: intl.t('shared_words.error')
      }
    },
    notification: {
      error: {
        contentWrapperClasses: [_constants.POST_MARKUP_CLASSES.HAS_ERROR],
        className: _constants.POST_MARKUP_CLASSES.FC_METHOD,
        icon: _constants.POST_MARKUP_ICONS.WARNING,
        hasOverlay: true,
        text: intl.t('shared_words.error')
      },
      default: {
        className: _constants.POST_MARKUP_CLASSES.FC_METHOD,
        icon: _constants.POST_MARKUP_ICONS.NOTIFICATION,
        text: intl.t('calendar.publish_methods.notification')
      }
    },
    autoPublishing: {
      contentWrapperClasses: [_constants.POST_MARKUP_CLASSES.IS_PUBLISHING],
      className: _constants.POST_MARKUP_CLASSES.FC_STATUS,
      icon: _constants.POST_MARKUP_ICONS.PUBLISHING
    },
    pinterestVideo: {
      approved: [{
        contentWrapperClasses: [_constants.POST_MARKUP_CLASSES.IS_VERIFIED],
        className: _constants.POST_MARKUP_CLASSES.FC_METHOD,
        hasOverlay: true,
        text: intl.t('shared_words.approved')
      }, {
        className: _constants.POST_MARKUP_CLASSES.FC_STATUS,
        icon: _constants.POST_MARKUP_ICONS.VERIFIED,
        hasOverlay: true
      }],
      rejected: [{
        contentWrapperClasses: [_constants.POST_MARKUP_CLASSES.HAS_ERROR],
        className: _constants.POST_MARKUP_CLASSES.FC_METHOD,
        hasOverlay: true,
        text: intl.t('shared_words.rejected')
      }, {
        className: _constants.POST_MARKUP_CLASSES.FC_STATUS,
        icon: _constants.POST_MARKUP_ICONS.DANGER,
        hasOverlay: true
      }],
      pending: [{
        contentWrapperClasses: [_constants.POST_MARKUP_CLASSES.IS_UNVERIFIED],
        className: _constants.POST_MARKUP_CLASSES.FC_METHOD,
        hasOverlay: true,
        text: intl.t('shared_words.pending')
      }, {
        className: _constants.POST_MARKUP_CLASSES.FC_STATUS,
        icon: _constants.POST_MARKUP_ICONS.PENDING,
        hasOverlay: true
      }],
      default: {
        className: _constants.POST_MARKUP_CLASSES.FC_METHOD,
        icon: _constants.POST_MARKUP_ICONS.NOTICE,
        hasOverlay: true,
        text: intl.t('shared_words.saved')
      }
    },
    youtubeShort: {
      className: _constants.POST_MARKUP_CLASSES.FC_TYPE,
      icon: _constants.POST_MARKUP_ICONS.YOUTUBE_SHORT
    }
  });

  _exports.markupOptionsByTag = markupOptionsByTag;
});